export default "__VITE_ASSET__D_hrx8jQ__"